import React, {Component} from 'react';
import {Link} from 'react-router';
import {message, Popconfirm, Table} from 'antd';
import moment from 'moment';
import {queryIncuBusinessArchve, queryIncuBusinessSigning} from '@api/incubator/business';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { contractTab, condition } = this.props;
    this.condition = condition;
    this.current = contractTab.concludePage || 1;
    this.getIncuBusinessSigning();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.getIncuBusinessSigning();
    }
  }

  getIncuBusinessSigning = () => {
    this.setState({
      loading: true,
    });
    const { pageSize } = this.props;
    queryIncuBusinessSigning({
      type: 'oregistapp',
      limit: pageSize,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange('oregistapp', this.current);
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
          loading: false,
        });
      }
    });
  };

  incuBusinessArchve = businessUuid => {
    queryIncuBusinessArchve({
      businessUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuBusinessArchving();
      } else {
        message.error(res.message);
      }
    });
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.getIncuBusinessSigning();
  };

  incuBusinessEnd = () => {};

  columns = () => {
    const termType = ['提前终止', '异常终止'];
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/address/info`}>{record.no}</Link>
        ),
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 250,
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '注册数',
        dataIndex: 'num',
        width: 100,
      },
      {
        title: '收费类型',
        dataIndex: 'itemType',
        width: 100,
        render: text => (text === 0 ? '免费' : '收费'),
      },
      {
        title: '合同情况',
        dataIndex: 'termType',
        width: 150,
        render: text => <span>{termType[text] || '正常'}</span>,
      },
      {
        title: '合同到期时间',
        dataIndex: 'deadline',
        width: 200,
        render: (text, record) => {
          let day = 0;
          if (text) {
            day = Math.floor((Date.now() - text) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'termStatus', // 0审核中；1已完成
        width: 160,
        render: (text, record) => {
          return (
            <div>
              <div>
                <Popconfirm
                  title="确定归档所选合同吗？"
                  onConfirm={() => this.incuBusinessArchve(record.uuid)}
                >
                  <a>归档合同 </a>
                </Popconfirm>
              </div>

              {!(record.termStatus > 0 || record.termStatus === 0) ? (
                <Link to={`/incubator/contract/${record.uuid}/termination/address`}>终止合同</Link>
              ) : (
                <span>终止合同({record.termStatus === 0 ? '审核中' : '已完成'})</span>
              )}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.state;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        onChange={this.onTableChange}
        scroll={{ x: 1350 }}
        rowKey="uuid"
        loading={loading}
      />
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/address/TableConclude.js